
<div
	class="stage-widget"
	:type="type"
	:compact="compact"
	:selected="selected"
	@click="handleClick"
>
	<div class="stage-header">
		<!-- @slot Used to display stage widget header <br/> Note : use html element with 'title' class to display header -->
		<slot name="header" />
	</div>
	<div class="stage-body">
		<!-- @slot Used to display widget content -->
		<slot />
	</div>
	<div class="stage-footer">
		<!-- @slot Used to display widget footer-->
		<slot name="footer" />
	</div>
	<div class="tip" :position="tipPosition">
		<svg viewBox="0 0 100 200" class="vertical">
			<polygon points="0 0, 100 100, 0 200" />
		</svg>
		<svg viewBox="0 0 200 100" class="horizontal">
			<polygon points="0 0, 100 100, 200 0" />
		</svg>
	</div>
</div>
